var firebaseConfig = {
    apiKey: "AIzaSyBZBWyzAmPq84zXXYxtP2j0yFuK3Dl7G3M",
    authDomain: "reactappbuilder-6f0ff.firebaseapp.com",
    databaseURL: "https://reactappbuilder-6f0ff.firebaseio.com",
    projectId: "reactappbuilder-6f0ff",
    storageBucket: "reactappbuilder-6f0ff.appspot.com",
    messagingSenderId: "745814333351",
    appId: "1:745814333351:web:c144baf21868eb1a"
};
// var firebaseConfig = {
//     apiKey: "AIzaSyB6qi-kxAML0YX7yThzojTysZMCPx8E8P0",
//     authDomain: "eventappbuilder-dev.firebaseapp.com",
//     databaseURL: "https://eventappbuilder-dev.firebaseio.com",
//     projectId: "eventappbuilder-dev",
//     storageBucket: "",
//     messagingSenderId: "108275717555",
//     appId: "1:108275717555:web:33b725d42f3123c8"
// };
exports.config = firebaseConfig;


// WEBPACK FOOTER //
// ./src/config/firebase_config.js